/** This file is auto-generated. Do not modify directly. */
import React from 'react';
import extendIcon from '../extendIcon';

const Pin = props => (
  <svg viewBox="0 0 400 400" width="1em" height="1em" {...props}>
    <path d="M185 2.4c5.8-.3 17.3-.2 23.1 0 68.8 2.5 130.4 61.9 134.6 130 .3 5.3.4 16 0 21.3-1.9 27.8-12.6 54.1-25 78.9C288 293.2 249.3 350 200.2 396.2l-3.6 3.2-3.6-3.4C129.2 330.5 61.3 252.2 51 159.2c-.7-6.2 0-24.9 0-24.9C58.1 65.9 115.9 5.5 185 2.4zm-15.8 53.4c-39.5 11.9-70.1 50.8-68.5 92.6-2.5 51.6 44.3 99.2 96.1 97.2 54.6 2.2 102.6-50.5 96-104.6-2.1-59.3-67.3-103.7-123.6-85.2z" />
  </svg>
);

export default extendIcon(Pin);
